export const escapeHtml = (text) => {
  if (!text) return '';
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
};

export const validateGeocodeResponse = (data) => {
  if (!data || typeof data !== 'object') {
    throw new Error('Invalid response format');
  }

  if (!data.success) {
    throw new Error(data.message || 'Geocoding failed');
  }

  if (!Array.isArray(data.data)) {
    throw new Error('Invalid data format');
  }

  return data;
};

export const validateRouteResponse = (data) => {
  if (!data || typeof data !== 'object') {
    throw new Error('Invalid response format');
  }

  if (!data.success) {
    throw new Error(data.message || 'Route fetch failed');
  }

  if (!data.data || typeof data.data !== 'object') {
    throw new Error('Invalid route data format');
  }

  return data;
};

export const validateSearchResponse = (data) => {
  if (!data || typeof data !== 'object') {
    throw new Error('Invalid response format');
  }

  if (!data.success) {
    throw new Error(data.message || 'Search failed');
  }

  if (!Array.isArray(data.data)) {
    throw new Error('Invalid search results format');
  }

  return data;
};

export const parseCoordinates = (locationString) => {
  const coordMatch = locationString.match(
    /^([-+]?\d+\.?\d*),\s*([-+]?\d+\.?\d*)$/
  );

  if (coordMatch) {
    return {
      latitude: parseFloat(coordMatch[1]),
      longitude: parseFloat(coordMatch[2]),
      name: locationString,
    };
  }

  return null;
};

export const createStopsString = (stops) => {
  return JSON.stringify(stops.map((s) => s.coordinates));
};
